import { FormPendingCount, PendingCount } from "types/Models/Filing";
import { FieldCheck } from "./getFieldChecks";

const EMPTY_SECTION_COUNT: PendingCount = { pending: 0, total: 0 };

/** Fields that block submit, per section and for the whole form */
export const getFormPendingCount = (checks: FieldCheck[]): FormPendingCount =>
  checks.reduce<FormPendingCount>(
    (count, { sectionKey, isFilled }) => {
      const section = count.sections[sectionKey] ?? EMPTY_SECTION_COUNT;
      const pendingDelta = isFilled ? 0 : 1;

      return {
        pending: count.pending + pendingDelta,
        total: count.total + 1,
        sections: {
          ...count.sections,
          [sectionKey]: {
            pending: section.pending + pendingDelta,
            total: section.total + 1,
          },
        },
      };
    },
    { pending: 0, total: 0, sections: {} }
  );
